import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.development";
import { constantvalues } from "../../const";
import { DtoSchool, DtoSchoolUser, TransferSchool } from "../../models/school.model";
import { Observable } from "rxjs";
import { Role, RolePayload } from "../../models/role.model";

@Injectable({
    providedIn: 'root'
})

export class SchoolService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getLogo(accountRefType: string|null, accountRef:string|null)
    {
        return this.httpClient.get<{ logo_url: string }>(`${this.baseURL}${constantvalues.API_URL.SCHOOL_LOGO}/${accountRefType}/${accountRef}`);
    }
    
    getSchools(clientAccountId: number, payload: any= {}){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.SCHOOL_UNDER_CLIENT_ACCOUNT}/${clientAccountId}`, {params: payload});
    }

    getSchool(schoolId: number): Observable<DtoSchool>{
        return this.httpClient.get<DtoSchool>(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/${schoolId}`);
    }

    createSchool(school: DtoSchool[], clientAccountId: number){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/${clientAccountId}`, school);
    }

    updateSchool(school: DtoSchool[]){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}`, school);
    }

    updateSchoolUser(schoolUser: DtoSchoolUser){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL_USER}`, schoolUser);
    }

    createSchoolUsers(school: DtoSchool[]){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/users`, school);
    }

    deleteSchool(schoolId: number){
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}`, {
            params: {
                schoolId: schoolId
            }
        });
    }

    resendActivationInvite(userId: number){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.RESEND_ACTIVATE_INVITE}/${userId}`);
    }

    updateUserStatus(userId: number){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.ACTIVATE_INACTIVATE_SCHOOL_USER}/${userId}`, null);
    }

    getIndependentSchools(payload: any): Observable<DtoSchool[]>{
        return this.httpClient.get<DtoSchool[]>(`${this.baseURL}${constantvalues.API_URL.INDEPENDENT_SCHOOL}`, {params: payload});
    }

    createSchoolUser(schoolUser: DtoSchoolUser[]){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL_USER}/${schoolUser[0].schoolId}`, schoolUser);
    }

    createIndependentSchool(schools: DtoSchool[]){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/${0}`, schools);
    }

    createRole(role: Role[], clientAccountId: number, individualSchoolId: number): Observable<Role> {
        if(clientAccountId > 0){
            role.forEach(role => 
                {
                    role.clientAccountId = clientAccountId;
                    role.individualSchoolId = individualSchoolId;
                    role.isIndividualEntity = false;
                }
            )
        }
        else{
            role.forEach(role => {
                role.clientAccountId = 0;
                role.individualSchoolId = individualSchoolId;
                role.isIndividualEntity = true;
                }
            )
        }
        return this.httpClient.post<Role>(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}`, role);
    }

    updateRole(role: Role){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}`, role);
    }

    updateRoleStatus(roleId: number){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}/${roleId}`, null);
    }

    // getRoles(clientAccountId: number, payload: any= {}, roleId: number = 0): Observable<Role>{
    //     return this.httpClient.get<Role>(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}/${clientAccountId}/${roleId}`, {params: payload});
    // }
    getRoles(rolePayload: RolePayload, roleId: number = 0): Observable<Role>{
        return this.httpClient.post<Role>(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}/${roleId}`, rolePayload);
    }

    getRoleList(roleId: number[]): Observable<Role[]>{
        return this.httpClient.post<Role[]>(`${this.baseURL}${constantvalues.API_URL.ROLE_LIST}`, roleId);
    }

    getRolesForAdmin(emailId: string): Observable<Role>{
        return this.httpClient.get<Role>(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}/${emailId}`);
    }

    getAssignedPackageId(emailId: string): Observable<number>{
        return this.httpClient.get<number>(`${this.baseURL}${constantvalues.API_URL.ASSIGNED_PACKAGE}/${emailId}`);
    }

    downloadFile(blobName: string) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/download/${blobName}`);
    }

    getSchoolUsers(emailId: string, schoolId: number = 0): Observable<DtoSchool[]>{
        return this.httpClient.get<DtoSchool[]>(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/${schoolId}/users/${emailId}`);
    }

    deleteRole(roleId: number){
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_ROLE}`, {
            params: {
                roleId: roleId
            }
        });
    }

    getSchoolData(emailId: string): Observable<DtoSchool>{
        return this.httpClient.get<DtoSchool>(`${this.baseURL}${constantvalues.API_URL.CRUD_SCHOOL}/data/${emailId}`);
    }

    raiseSchoolTransferRequest(transferSchool: TransferSchool, schoolId: number){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.RAISE_SCHOOL_TRANSFER_REQUEST}/${schoolId}`, transferSchool);
    }

    transferSchool(transferSchoolId: number){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.TRANSFER_SCHOOL}/${transferSchoolId}`, null);
    }

    requestAccessToViewReport(role: Role){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.REQUEST_ACCESS}`, role);
    }

    grantAccessToViewReport(requestAccessId: number){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GRANT_ACCESS}/${requestAccessId}`, null);
    }

    declineAccessToViewReport(requestAccessId: number){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.DECLINE_ACCESS}/${requestAccessId}`, null);
    }

    checkIfAnyActiveAccessRequestExists(email: string){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CHECK_ACTIVE_ACCESS_REQUEST_EXISTS}/${email}`);
    }

    checkIfSchoolIsTranferredToIndividualSchool(referenceId: number){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CHECK_SCHOOL_TRANSFER_TO_INDIVIDUAL_SCHOOL}/${referenceId}`);
    }
}